import type { ViewStyle } from 'react-native';

import { getStyleSheet } from './style-sheet-memo';

export const opacity = (opacity: ViewStyle['opacity']) =>
  getStyleSheet({ opacity });

export const overflow = (overflow: ViewStyle['overflow']) =>
  getStyleSheet({ overflow });
